export default __webpack_public_path__ + "static/media/twitter.3756992b.svg";